import { base64Decode } from './core.js';
import { wlog } from './wlog.js';

/**
 * Extracts the email from the pageUrl and returns it if found
 * @param {string} pageUrl the url of the page
 * @returns {string | null} the email if found, null otherwise
 */
export const extractEmailFromParams = (pageUrl: string): string | null => {
  const wemail = /wemail=([^&#]+)/.exec(pageUrl) ?? null;

  if (wemail) {
    // wemail may arrive URL-encoded (e.g. jane%40example.com) when the embedding
    // page constructs the URL with encodeURIComponent or similar. Decode here so
    // downstream ETL pipeline sees a well-formed address.
    try {
      return decodeURIComponent(wemail[1]);
    } catch {
      // Malformed percent-encoding — fall back to the raw capture rather
      // than crashing the player's init path.
      return wemail[1];
    }
  }

  const wkey = /wkey=([^&#]+)/.exec(pageUrl) ?? null;

  if (wkey) {
    const base64Email = wkey[1];
    try {
      const decodedEmail = base64Decode(base64Email);
      return decodedEmail;
    } catch (error) {
      wlog.info('Failed to decode email from wkey', error);
    }
  }

  return null;
};
